import { render, staticRenderFns } from "./SideNav.vue?vue&type=template&id=f2c1b9f6&scoped=true"
import script from "./SideNav.vue?vue&type=script&lang=js"
export * from "./SideNav.vue?vue&type=script&lang=js"
import style0 from "./SideNav.vue?vue&type=style&index=0&id=f2c1b9f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c1b9f6",
  null
  
)

export default component.exports